var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerySadEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_2481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.5C5.88325 24.5 0.5 19.1167 0.5 12.5C0.5 5.88325 5.88325 0.5 12.5 0.5C19.1167 0.5 24.5 5.88325 24.5 12.5C24.5 19.1167 19.1167 24.5 12.5 24.5ZM12.5 2C6.71025 2 2 6.71025 2 12.5C2 18.2897 6.71025 23 12.5 23C18.2897 23 23 18.2897 23 12.5C23 6.71025 18.2897 2 12.5 2ZM18.0855 17.671C18.1736 17.627 18.2522 17.566 18.3167 17.4916C18.3813 17.4172 18.4305 17.3308 18.4617 17.2374C18.4928 17.1439 18.5053 17.0453 18.4983 16.947C18.4913 16.8488 18.465 16.7528 18.421 16.6647C18.351 16.525 16.6658 13.25 12.5 13.25C8.33425 13.25 6.649 16.525 6.579 16.6645C6.49048 16.8417 6.47583 17.0468 6.53824 17.2348C6.60066 17.4228 6.73507 17.5784 6.912 17.6675C7.08927 17.7566 7.29459 17.7721 7.48321 17.7105C7.67183 17.6489 7.82847 17.5153 7.919 17.3388C7.97325 17.233 9.2825 14.75 12.5 14.75C15.7175 14.75 17.0268 17.233 17.079 17.3355C17.1413 17.4603 17.2371 17.5652 17.3558 17.6385C17.4745 17.7117 17.6113 17.7503 17.7507 17.75C17.8632 17.75 17.9778 17.7247 18.0855 17.671ZM16.25 11C15.4228 11 14.75 10.3272 14.75 9.5C14.75 8.67275 15.4228 8 16.25 8C17.0772 8 17.75 8.67275 17.75 9.5C17.75 10.3272 17.0772 11 16.25 11ZM8.75 11C7.92275 11 7.25 10.3272 7.25 9.5C7.25 8.67275 7.92275 8 8.75 8C9.57725 8 10.25 8.67275 10.25 9.5C10.25 10.3272 9.57725 11 8.75 11Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_2481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySadEmoji);
export default __webpack_public_path__ + "static/media/verySadEmoji.16f77283546a06a588b6a8fec5c9de65.svg";
export { ForwardRef as ReactComponent };